var format = 'mmmm dd, yyyy',
    formatSubmit = 'yyyy-mm-dd';

/**
 * Returns an object containing multiple configuration options for the pickadate javascript widget.
 * http://amsul.ca/pickadate.js/date/
 *
 * @class pickadateConfigs
 * @static
 */
module.exports = {
  dob: {
    // Formats
    format: format,
    formatSubmit: formatSubmit,
    // From what I can tell upper vs lower case is the only difference between the formats.
    momentFormat: format.toUpperCase(),
    momentFormatSubmit: formatSubmit.toUpperCase(),
    hiddenName: true,
    // Allow dropdown menu for year and month selection
    selectYears: 150,
    selectMonths: true,
    // Date limits
    min: new Date(1900, 0, 1),
    max: new Date()
  }
};
